import React from 'react';
import ReactMapGL, { Marker, Popup } from 'react-map-gl';

export default function StoryMap(props) {


  return (
    <ReactMapGL
      {...props.viewport}
      mapboxApiAccessToken={process.env.REACT_APP_MAPBOX_TOKEN}
      mapStyle='mapbox://styles/roamiiing/ck8fmmyds2k0u1invifuwwrrb'
      >

        {props.markers.map(e => {

          return (
          <Marker
            key={props.markers.indexOf(e)}
            latitude={e.latitude}
            longitude={e.longitude}
            offsetLeft={-24}
            offsetTop={0}
            >
            <span role='img' className='mapemoji'>{e.text}</span>
          </Marker>);
        })}

        {
          props.popups.map(e => (
            <Popup
              key={props.popups.indexOf(e)}
              latitude={e.latitude}
              longitude={e.longitude}
              closeButton={false}
              closeOnClick={false}
              >
              {e.img ? <img src={e.img} alt='' className='mapimg' /> : null}
              {e.jsx || null}
            </Popup>
          ))
        }
      
    </ReactMapGL>
  );
}
